var _excluded = ["currentIndex", "images", "open", "onChange", "onClose"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import ImageViewer from 'react-images-viewer';
function GalleryViewer(_ref) {
  var currentIndex = _ref.currentIndex,
    images = _ref.images,
    open = _ref.open,
    onChange = _ref.onChange,
    onClose = _ref.onClose,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var handleNext = function handleNext() {
    onChange(currentIndex + 1);
  };
  var handlePrev = function handlePrev() {
    onChange(currentIndex - 1);
  };
  var prepareImages = function prepareImages(imgs) {
    return imgs.map(function (img) {
      return {
        src: img.path,
        thumbnail: img.thumb,
        caption: img.caption
      };
    });
  };
  return /*#__PURE__*/React.createElement(ImageViewer, _extends({
    currImg: currentIndex,
    isOpen: open,
    onClose: onClose,
    imgs: prepareImages(images),
    onClickPrev: handlePrev,
    onClickNext: handleNext
  }, rest));
}
GalleryViewer.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   *
   */
  currentIndex: PropTypes.number,
  /**
   * List of images
   */
  images: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string,
    thumb: PropTypes.string,
    caption: PropTypes.string
  })).isRequired,
  open: PropTypes.bool,
  /**
   */
  onChange: PropTypes.func.isRequired,
  /**
   */
  onClose: PropTypes.func.isRequired
} : {};
GalleryViewer.defaultProps = {
  currentIndex: 0,
  open: false
};
export default GalleryViewer;